import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';

const BankAccountChange = props => {
  const intl = useIntl();
  const { log } = props;

  if (log.oldValue === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedBankAccount, {
          property: RenderProperty({ intl, log }),
          iban: log.newValue,
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.DeletedBankAccount, {
        property: RenderProperty({ intl, log }),
        iban: log.oldValue,
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default BankAccountChange;
